export enum TypeVideoEmbedEnum {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  DAILYMOTION = 'DAILYMOTION',
  SLIDESHARE = 'SLIDESHARE',
  BITTUBE = 'BITTUBE',
}
